// Lightweight device fingerprint. NOT a cryptographic fingerprint —
// just enough entropy to flag duplicate devices used across different phones.
export async function getDeviceFingerprint() {
  try {
    const nav = window.navigator || {};
    const scr = window.screen || {};
    const canvas = document.createElement("canvas");
    canvas.width = 200; canvas.height = 40;
    const ctx = canvas.getContext("2d");
    if (ctx) {
      ctx.textBaseline = "top";
      ctx.font = "14px Arial";
      ctx.fillStyle = "#F60";
      ctx.fillRect(0, 0, 60, 20);
      ctx.fillStyle = "#069";
      ctx.fillText("MYDAWA.fp", 4, 4);
    }
    const canvasData = canvas.toDataURL();
    const components = [
      nav.userAgent,
      nav.language,
      nav.platform,
      `${scr.width}x${scr.height}x${scr.colorDepth}`,
      new Date().getTimezoneOffset(),
      nav.hardwareConcurrency,
      nav.deviceMemory,
      !!nav.cookieEnabled,
      canvasData.slice(-100),
    ].join("|");
    const buf = new TextEncoder().encode(components);
    const hashBuf = await crypto.subtle.digest("SHA-256", buf);
    const hex = Array.from(new Uint8Array(hashBuf))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    return {
      fp: hex.slice(0, 32),
      meta: {
        ua: (nav.userAgent || "").slice(0, 100),
        lang: nav.language || "",
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        screen: `${scr.width}x${scr.height}`,
        platform: nav.platform || "",
      },
    };
  } catch {
    return { fp: "", meta: {} };
  }
}
